import styled, { css } from 'styled-components';

export const PriceBubble = styled.div`
  float: right;
  padding-left: 20px;
`;

export const ParentComponent = styled.div<{ isSelected: boolean; isOption: boolean }>`
  cursor: pointer;
  font-size: 16px;
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  background: ${({ theme, isSelected }) => (isSelected ? theme.customColors.tertiary : 'none')};

  ${({ isOption }) =>
    isOption &&
    css`
      padding: 6px 55px 6px 15px;
    `};
`;
